import { FeaturesStep4Form } from './features-step4-form';
import { InputText } from '../../../classes/input-text';
import { InputBase } from '../../../classes/input-base';

export class FeaturesStep4FormFreeboosky extends FeaturesStep4Form {
	amazonLink = new InputText({
		key: 'amazonLink',
		label: 'Amazon Url',
		buttonSymbol: 'Go',
		required: true,
		blur: true,
	});

	kindleUnlimited = new InputBase({
		key: 'kindleUnlimited',
		label: 'Is your book enrolled in Kindle Unlimited?',
		controlType: 'checkbox',
	});

	bookFree = new InputBase({
		key: 'bookFree',
		label: 'Is this book free?',
		controlType: 'checkbox',
		value: false,
	});

	freeStartDate = new InputBase({
		key: 'freeStartDate',
		label: 'Start Date',
		controlType: 'date',
	});

	freeEndDate = new InputBase({
		key: 'freeEndDate',
		label: 'End Date',
		controlType: 'date',
	});

	bookPriceDuringPromo = new InputText({
		key: 'bookPriceDuringPromo',
		label: 'Book Price During Promotion',
		required: true,
		type: 'number',
		addonSymbol: '$',
		min: 0,
	});
}
